import { render, staticRenderFns } from "./TemplateMailModal.vue?vue&type=template&id=4b68d050&scoped=true&"
import script from "./TemplateMailModal.vue?vue&type=script&lang=js&"
export * from "./TemplateMailModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMailModal.vue?vue&type=style&index=0&id=4b68d050&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68d050",
  null
  
)

export default component.exports